import React, { useEffect, useState, Component } from 'react';
export const ConsultationForm = () => {
  // State declarations would go here
  const [formData, setFormData] = useState({
    wru: '',
    reference: '',
    name: '',
    fgname: '',
    age: '',
    gender: '',
    email: '',
    address: '',
    city: '',
    pin: '',
    whatsapp: '',
    thirst: '',
    appetite: '',
    foodHabits: {
      fruits: false,
      healthyFood: false,
      noWaterBeforeAfter: false,
      waterBeforeAfter: false
    },
    sleep: '',
    dreams: '',
    hygiene: '',
    addiction: '',
    lifestyle: {
      active: false,
      healthy: false,
      urban: false,
      rural: false,
      bohemian: false,
      minimalist: false,
      sustainable: false
    },
    body: '',
    temperature: '',
    mentalcondition: '',
    bp: '',
    pulse: '',
    bowel: '',
    urineFrequencyDay: '',
    urineFrequencyNight: '',
    urineColor: '',
    urineSmell: '',
    skin: '',
    shair: '',
    bhair: '',
    nails: '',
    bodyOdor: '',
    mouthOdor: '',
    throat: '',
    oedma: '',
    eyes: '',
    ears: '',
    lips: '',
    medicalHistory: {
      diabetic: false,
      preDiabetic: false,
      heartProblem: false,
      kidneyProblem: false,
      highBloodPressure: false,
      arthritis: false,
      cancer: false,
      hivAids: false,
      hepatitis: false,
      stroke: false,
      paralysis: false,
      alzheimers: false,
      asthma: false,
      organTransplant: false
    },
    mensturation: '',
    cdays: '',
    painful: {
      noPain: false,
      before: false,
      during: false,
      after: false
    },
    clots: '',
    flowType: '',
    isPregnant: '',
    pregnancyMonth: '',
    isMenopause: '',
    gynecologicalConditions: {
      cancers: false,
      endometriosis: false,
      pcos: false,
      dysmenorrhea: false,
      amenorrhea: false,
      menorrhagia: false,
      pms: false,
      adenomyosis: false,
      utis: false,
      anemia: false,
      infertility: false,
      fibroidsCysts: false
    },
    ccomplaint: '',
    presentill: '',
    pastill: '',
    fhistory: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const isFemale = formData.gender === 'Female';
  // Event handlers
  const handleChange = e => {
    const {
      id,
      value
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [id]: value
    }));
  };
  // ... existing handlers ...
  const handleFoodHabitsChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      foodHabits: {
        ...prevData.foodHabits,
        [name]: checked
      }
    }));
  };
  const handleLifestyleChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      lifestyle: {
        ...prevData.lifestyle,
        [name]: checked
      }
    }));
  };
  const handlePainfulChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      painful: {
        ...prevData.painful,
        [name]: checked
      }
    }));
  };
  // New handlers for medical history and gynecological conditions
  const handleMedicalHistoryChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      medicalHistory: {
        ...prevData.medicalHistory,
        [name]: checked
      }
    }));
  };
  const handleGynecologicalConditionsChange = e => {
    const {
      name,
      checked
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      gynecologicalConditions: {
        ...prevData.gynecologicalConditions,
        [name]: checked
      }
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!agreedToTerms) {
      setSubmissionError('Please read and agree to the informed consent before submitting.');
      return;
    }
    setIsSubmitting(true);
    setSubmissionError('');
    try {
      // Construct form data as text message
      let message = 'Online Treatment / Consultation Form\n\n';
      // Basic Information
      message += '--- Basic Information ---\n';
      message += `Are You: ${formData.wru}\n`;
      message += `Reference: ${formData.reference}\n\n`;
      // Personal Information
      message += '--- Personal Information ---\n';
      message += `Name: ${formData.name}\n`;
      message += `Father/Guardian: ${formData.fgname}\n`;
      message += `Age: ${formData.age}\n`;
      message += `Gender: ${formData.gender}\n`;
      message += `Email: ${formData.email}\n`;
      message += `Address: ${formData.address}\n`;
      message += `City: ${formData.city}\n`;
      message += `Pin Code: ${formData.pin}\n`;
      message += `WhatsApp: ${formData.whatsapp}\n\n`;
      // Health & Lifestyle
      message += '--- Health & Lifestyle ---\n';
      message += `Thirst: ${formData.thirst}\n`;
      message += `Appetite: ${formData.appetite}\n`;
      // Food Habits
      message += 'Food Habits: ';
      const foodHabits = [];
      if (formData.foodHabits.fruits) foodHabits.push('Takes Fruits and Dry fruits');
      if (formData.foodHabits.healthyFood) foodHabits.push('Takes 3 Times Healthy Food');
      if (formData.foodHabits.noWaterBeforeAfter) foodHabits.push('No water before/after meals');
      if (formData.foodHabits.waterBeforeAfter) foodHabits.push('Takes water before/after meals');
      message += foodHabits.join(', ') || 'None specified';
      message += '\n';
      message += `Sleep: ${formData.sleep}\n`;
      message += `Dreams: ${formData.dreams}\n`;
      message += `Personal Hygiene: ${formData.hygiene}\n`;
      message += `Addiction: ${formData.addiction}\n`;
      // Lifestyle
      message += 'Lifestyle: ';
      const lifestyle = [];
      if (formData.lifestyle.active) lifestyle.push('Active');
      if (formData.lifestyle.healthy) lifestyle.push('Healthy');
      if (formData.lifestyle.urban) lifestyle.push('Urban');
      if (formData.lifestyle.rural) lifestyle.push('Rural');
      if (formData.lifestyle.bohemian) lifestyle.push('Bohemian');
      if (formData.lifestyle.minimalist) lifestyle.push('Minimalist');
      if (formData.lifestyle.sustainable) lifestyle.push('Sustainable');
      message += lifestyle.join(', ') || 'None specified';
      message += '\n\n';
      // Medical History
      message += '--- Medical History ---\n';
      const medicalHistory = [];
      if (formData.medicalHistory.diabetic) medicalHistory.push('Diabetic');
      if (formData.medicalHistory.preDiabetic) medicalHistory.push('Pre-Diabetic');
      if (formData.medicalHistory.heartProblem) medicalHistory.push('Heart Related Problem');
      if (formData.medicalHistory.kidneyProblem) medicalHistory.push('Kidney Related Problem');
      if (formData.medicalHistory.highBloodPressure) medicalHistory.push('High Blood Pressure');
      if (formData.medicalHistory.arthritis) medicalHistory.push('Arthritis');
      if (formData.medicalHistory.cancer) medicalHistory.push('Cancer');
      if (formData.medicalHistory.hivAids) medicalHistory.push('HIV/AIDS');
      if (formData.medicalHistory.hepatitis) medicalHistory.push('Hepatitis');
      if (formData.medicalHistory.stroke) medicalHistory.push('Stroke');
      if (formData.medicalHistory.paralysis) medicalHistory.push('Paralysis');
      if (formData.medicalHistory.alzheimers) medicalHistory.push("Alzheimer's Disease");
      if (formData.medicalHistory.asthma) medicalHistory.push('Asthma');
      if (formData.medicalHistory.organTransplant) medicalHistory.push('Any Organ Transplant');
      message += `Disease History: ${medicalHistory.join(', ') || 'None'}\n\n`;
      // Physical Attributes
      message += '--- Physical Attributes ---\n';
      message += `Body Type: ${formData.body}\n`;
      message += `Temperature: ${formData.temperature}\n`;
      message += `Mental Condition: ${formData.mentalcondition}\n`;
      message += `Blood Pressure: ${formData.bp}\n`;
      message += `Pulse: ${formData.pulse}\n\n`;
      // Bodily Functions
      message += '--- Bodily Functions ---\n';
      message += `Bowel Movement: ${formData.bowel}\n`;
      message += `Urine Frequency (In Day): ${formData.urineFrequencyDay}\n`;
      message += `Urine Frequency (In Night): ${formData.urineFrequencyNight}\n`;
      message += `Urine Color: ${formData.urineColor}\n`;
      message += `Urine Smell: ${formData.urineSmell}\n\n`;
      // Physical Appearance
      message += '--- Physical Appearance ---\n';
      message += `Skin: ${formData.skin}\n`;
      message += `Scalp(Hair): ${formData.shair}\n`;
      message += `Body(Hair): ${formData.bhair}\n`;
      // Nails
      message += `Nails: ${formData.nails || 'None specified'}\n\n`;
      // Body & Mouth Odor
      message += '--- Body & Mouth Odor ---\n';
      // Body Odor
      message += `Body Odor: ${formData.bodyOdor || 'None specified'}\n`;
      // Mouth Odor
      message += `Mouth Odor: ${formData.mouthOdor || 'None specified'}\n\n`;
      // Body Parts
      message += '--- Body Parts ---\n';
      // Throat
      message += `Throat: ${formData.throat || 'None specified'}\n`;
      message += `Edema: ${formData.oedma}\n`;
      message += `Eyes: ${formData.eyes}\n`;
      message += `Ears: ${formData.ears}\n`;
      // Lips
      message += `Lips: ${formData.lips || 'None specified'}\n\n`;
      // Female-specific information
      if (formData.gender === 'Female') {
        message += '--- Female-specific Information ---\n';
        message += `Pregnant: ${formData.isPregnant}\n`;
        if (formData.isPregnant === 'Yes') {
          message += `Pregnancy Month: ${formData.pregnancyMonth}\n`;
        }
        message += `Menopause: ${formData.isMenopause}\n`;
        message += `Mensturation Duration: ${formData.mensturation}\n`;
        message += `Cycle days: ${formData.cdays}\n`;
        // Painful
        message += 'Painful: ';
        const painful = [];
        if (formData.painful.noPain) painful.push('No Pain');
        if (formData.painful.before) painful.push('Before');
        if (formData.painful.during) painful.push('During');
        if (formData.painful.after) painful.push('After');
        message += painful.join(', ') || 'None specified';
        message += '\n';
        message += `Clots: ${formData.clots}\n`;
        // Flow Type
        message += `Flow Type: ${formData.flowType || 'None specified'}\n`;
        // Gynecological Conditions
        const gynecologicalConditions = [];
        if (formData.gynecologicalConditions.cancers) gynecologicalConditions.push('Cancers (Breast, ovarian, cervical)');
        if (formData.gynecologicalConditions.endometriosis) gynecologicalConditions.push('Endometriosis');
        if (formData.gynecologicalConditions.pcos) gynecologicalConditions.push('Polycystic Ovary Syndrome (PCOS)');
        if (formData.gynecologicalConditions.dysmenorrhea) gynecologicalConditions.push('Dysmenorrhea (cramps)');
        if (formData.gynecologicalConditions.amenorrhea) gynecologicalConditions.push('Amenorrhea (absent periods)');
        if (formData.gynecologicalConditions.menorrhagia) gynecologicalConditions.push('Menorrhagia (heavy bleeding)');
        if (formData.gynecologicalConditions.pms) gynecologicalConditions.push('Premenstrual Syndrome (PMS)');
        if (formData.gynecologicalConditions.adenomyosis) gynecologicalConditions.push('Adenomyosis');
        if (formData.gynecologicalConditions.utis) gynecologicalConditions.push('Urinary Tract Infections (UTIs)');
        if (formData.gynecologicalConditions.anemia) gynecologicalConditions.push('Anemia');
        if (formData.gynecologicalConditions.infertility) gynecologicalConditions.push('Infertility');
        if (formData.gynecologicalConditions.fibroidsCysts) gynecologicalConditions.push('Fibroids / Cysts');
        message += `Gynecological Conditions: ${gynecologicalConditions.join(', ') || 'None'}\n\n`;
      }
      // Chief Complaint and Illness Information
      message += '--- Complaint & Illness Information ---\n';
      message += `Chief Complaint: ${formData.ccomplaint}\n`;
      message += `Present Illness: ${formData.presentill}\n`;
      message += `Past Illness: ${formData.pastill}\n`;
      message += `Family History: ${formData.fhistory}\n`;
      // Encode the message for URL
      const encodedMessage = encodeURIComponent(message);
      // Construct WhatsApp URL
      const whatsappURL = `https://wa.me/918303699990?text=${encodedMessage}`;
      // Open WhatsApp in a new tab
      window.open(whatsappURL, '_blank');
      // Mark form as submitted
      setFormSubmitted(true);
      setIsSubmitting(false);
    } catch (error) {
      setSubmissionError('There was an error submitting the form. Please try again.');
      setIsSubmitting(false);
    }
  };
  // Consent popup component
  const ConsentPopup = () => {
    if (!showConsentPopup) return null;
    return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-9">
        <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto" data-id="element-10">
          <div className="sticky top-0 bg-blue-800 text-white px-6 py-4 rounded-t-lg flex justify-between items-center" data-id="element-11">
            <h3 className="text-xl font-bold" data-id="element-12">Informed Consent Form</h3>
            <button onClick={() => setShowConsentPopup(false)} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-13">
              <span className="text-2xl" data-id="element-14">&times;</span>
            </button>
          </div>
          <div className="p-6" data-id="element-15">
            <h2 className="text-xl font-bold mb-4 text-center" data-id="element-16">
              Informed Consent Form
            </h2>
            <h3 className="text-lg font-semibold mb-3 text-center" data-id="element-17">
              (For Acupuncture Treatment)
            </h3>
            <p className="mb-4" data-id="element-18">
              Please read this document carefully and completely. This is an
              informed consent that explains the expectations and risks
              associated with Acupuncture Treatment.
            </p>
            <ol className="list-decimal pl-5 space-y-4" data-id="element-19">
              <li data-id="element-20">
                I understand that the professional practitioners
                (acupuncturists) in Aatmshakti Institute of Integrated Medical
                Research(AIIMR) will treat my conditions within their scope of
                practice of Traditional Chinese Medicine (TCM)/ Master Tung's
                Acupuncture / Auricular Medicine with seeds and Acupuncture /
                Dr. Tan Balance Acupuncture Method / Acupressure Therapy /
                Colour Therapy / Korean Cosmetic Acupuncture / Abdominal
                Acupuncture Scalp Acupuncture Neval Acupuncture/ Static Cupping
                /Moving Cupping / Fire Cupping / Blood Letting, which may limit
                treatment choices.
              </li>
              <li data-id="element-21">
                I understand that "Acupuncture" treatment involves the
                penetration of skin by sterile, one-time-use, disposable
                filiform needles. There are additional methods of treatment,
                within the scope of acupuncture and "Traditional Chinese
                Medicine" that may be used in addition to, instead, or in
                combination with needles. The scope includes:
                <ol className="list-decimal pl-5 mt-2 space-y-1" data-id="element-22">
                  <li data-id="element-23">
                    Assessment by the collection of data by interviewing,
                    observation, palpation, pulse taking, tongue observation and
                    other methods;
                  </li>
                  <li data-id="element-24">
                    Acupressure and therapeutic massage (Tui-Na, (Chinese
                    massage));
                  </li>
                  <li data-id="element-25">
                    Dietary herbal supplements and Chinese or Western herbal
                    medicine;
                  </li>
                  <li data-id="element-26">Nutritional counseling;</li>
                  <li data-id="element-27">
                    Energy-flow work, exercises or other prescribed forms of
                    movement (e.g. Qigong, Tai Chi);
                  </li>
                  <li data-id="element-28">
                    Heat therapy with the use of mugwort (moxibustion) or a heat
                    lamp over localized areas;
                  </li>
                  <li data-id="element-29">Glass cups "fire- cupping", plastic suction cups;</li>
                  <li data-id="element-30">Gua Sha tools for scraping;</li>
                  <li data-id="element-31">Electrical stimulation of acupuncture needles</li>
                  <li data-id="element-32">LED (Light therapy)</li>
                </ol>
              </li>
              <li data-id="element-33">
                I understand that as the patient, I must inform the
                practitioners of medications, medical history, and sensitivities
                to smoke or scents, if I am currently pregnant, have a bleeding
                disorder or any communicable or contagious conditions that could
                be passed to others.
              </li>
              <li data-id="element-34">
                I understand that I must lie still during treatment; am
                responsible to ask questions regarding treatment details if
                explanations provided are not clear or understood; have a right
                to refuse treatment at any point.
              </li>
              <li data-id="element-35">
                I understand that patients are advised to tell their doctor they
                are receiving TCM acupuncture, to avoid possible treatment
                conflicts. Patients are encouraged to report their outcomes to
                their doctors.
              </li>
              <li data-id="element-36">
                I understand that the assessment, diagnosis, and treatment of
                medical conditions by TCM varies from Western medicine.
              </li>
              <li data-id="element-37">
                I understand that I must give the clinic 24 hours' notice of
                cancellation otherwise I may be charged the full session fee.
              </li>
              <li data-id="element-38">
                I understand that acupuncture does not typically provide an
                instant cure. For most serious or chronic ailments, more than
                one treatment, along with some lifestyle and dietary changes,
                may be necessary for noticeable changes to take place.
              </li>
            </ol>
            <h3 className="text-lg font-semibold mt-6 mb-3" data-id="element-39">
              Risks and Complications of Acupuncture Treatment
            </h3>
            <p className="mb-4" data-id="element-40">
              I understand that there is risk of side effects, which may
              include:
            </p>
            <div className="space-y-3" data-id="element-41">
              <p data-id="element-42">
                <strong data-id="element-43">Pain</strong> - Acupuncture needling may cause an
                initial "prick" as it punctures the skin followed by a temporary
                achy sensation, numbness, or tingling at or near the needling
                sites that may radiate. These are all normal needling sensations
                and may last a few days. Please tell your practitioner if any
                sensation is too strong so they can adjust the treatment
                accordingly.
              </p>
              <p data-id="element-44">
                Tui-Na (Chinese Massage), acupuncture insertion, acupuncture
                stimulation, electro-acupuncture, cupping, Gua Sha, qigong
                (exercise), may all cause pain. Patient feedback is important
                for the practitioner to adjust the treatment when necessary;
                Electrical stimulation of acupuncture needles produces a mild
                vibration/tapping sensation on the needles, which may be
                painful;
              </p>
              <p data-id="element-45">
                <strong data-id="element-46">Bruising</strong> - Bruising may occur anytime we
                puncture the skin. If you have bruises on some area of the body,
                please inform your practitioner. The normal reaction of cupping,
                "gua sha" and scraping is to leave red marks or bruising. This
                will usually slowly resolve on it's own with 5-10 days and is
                part of the intentional therapeutic effect.
              </p>
              <p data-id="element-47">
                <strong data-id="element-48">Infection</strong> - It is possible to develop an
                infection whenever the skin is punctured despite using single
                use disposable needles and clean needle technique. Please inform
                us if you have a known immune problem so we can take special
                precautions.
              </p>
              <p data-id="element-49">
                <strong data-id="element-50">Burns & Smoke Irritation</strong> - Heat therapy and
                moxibustion may cause redness, blistering or unintentional burns
                and/or scarring. It is important to verbally communicate with
                your practitioner if any heat therapy feels too hot. Smoke from
                moxibustion may cause coughing, lung irritation, headaches or
                allergic reactions for those sensitive to scents or smoke;
              </p>
              <p data-id="element-51">
                <strong data-id="element-52">Feeling of Relaxed or Sleepy</strong> - It is common to
                feel relaxed or sleepy after treatment so avoid getting up too
                quickly and rushing anywhere directly after treatment. Give
                yourself time to adjust after treatment before driving or using
                the stairs or any other potentially dangerous activity.
              </p>
              <p data-id="element-53">
                <strong data-id="element-54">Dizziness & Fainting</strong> - Dizziness or fainting
                can occur as a result of treatment. Please tell us if you are
                prone to fainting. Important factors that can decrease this risk
                include ensuring you have had sufficient food, ensuring you have
                not had any drugs or alcohol prior to treatment, communicating
                if the stimulation is uncomfortably strong, and getting up
                slowly after treatment.
              </p>
              <p data-id="element-55">
                <strong data-id="element-56">Dizziness & Fainting</strong> - Dizziness or fainting
                can occur as a result of treatment. Please tell us if you are
                prone to fainting. Important factors that can decrease this risk
                include ensuring you have had sufficient food, ensuring you have
                not had any drugs or alcohol prior to treatment, communicating
                if the stimulation is uncomfortably strong, and getting up
                slowly after treatment.
              </p>
            </div>
            <h3 className="text-lg font-semibold mt-6 mb-3" data-id="element-57">
              Revoking consent
            </h3>
            <p className="mb-4" data-id="element-58">
              I understand that this initial consent is to educate and explain
              my treatment and that I may verbally revoke my consent to any
              treatment at any time.
            </p>
            <p className="mb-4" data-id="element-59">
              I therefore agree to waive any rights for legal liability that I
              could have against "Aatmshakti Institute of Integrated Medical
              Research" and/or the acupuncture therapist.
            </p>
            <p className="mb-4" data-id="element-60">
              I hereby request and give consent for treatment at the "Aatmshakti
              Institute of Integrated Medical Research" using modalities within
              the scope of "Acupuncture" and "Traditional Chinese Medicine" as
              described above.
            </p>
            <p className="font-semibold" data-id="element-61">
              By Agreeing / signing below, I confirm I have read, understood,
              asked questions and agree to the above Terms of Treatment.
            </p>
            <div className="mt-6 text-center" data-id="element-62">
              <button onClick={() => setShowConsentPopup(false)} className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-63">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  return <div className="container max-w-4xl mx-auto bg-white p-4 sm:p-6 rounded-lg shadow-lg" data-id="element-64">
      {/* Header with Logo Image */}
      <div className="mb-6" data-id="element-65">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gokj4dqyRmyFLxPowgMCDA/image.png" alt="Aatmshakti Institute of Integrated Medical Research" className="w-full h-auto mb-4" data-id="element-66" />
        <div className="text-xl sm:text-2xl font-bold text-center text-blue-800" data-id="element-67">
          Online Treatment / Consultation Form (ऑनलाइन उपचार / परामर्श प्रपत्र)
        </div>
      </div>
      {/* Render the consent popup */}
      <ConsentPopup data-id="element-68" />
      {/* Payment QR Code Section */}
      <div className="mb-8 p-3 sm:p-4 bg-blue-50 rounded-lg" data-id="element-69">
        <h3 className="text-lg sm:text-xl font-bold text-center text-blue-800 mb-3 sm:mb-4" data-id="element-70">
          Consultation Fee - ₹200
        </h3>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-71">
          <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm" data-id="element-72">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tkvQYBZJCtiXUEKjqPRQFu/pasted-image.png" alt="Payment QR Code" className="w-full max-w-[160px] sm:max-w-[200px]" data-id="element-73" />
          </div>
          <div className="max-w-xs" data-id="element-74">
            <p className="text-sm sm:text-base text-gray-700 text-center mb-2" data-id="element-75">
              Scan the QR code to pay via UPI
            </p>
            <p className="text-sm sm:text-base text-gray-700 font-medium text-center" data-id="element-76">
              UPI ID: annukapoor@okicici
            </p>
            <p className="text-xs sm:text-sm text-gray-600 text-center mt-2" data-id="element-77">
              Please make the payment before submitting the form
            </p>
          </div>
        </div>
      </div>
      {/* Error message display */}
      {submissionError && <div className="bg-red-50 border-l-4 border-red-500 p-3 sm:p-4 mb-6" data-id="element-78">
          <div className="flex" data-id="element-79">
            <div className="ml-3" data-id="element-80">
              <p className="text-sm text-red-700" data-id="element-81">{submissionError}</p>
            </div>
          </div>
        </div>}
      {formSubmitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-4 sm:p-6 text-center" data-id="element-82">
          <h2 className="text-xl sm:text-2xl font-bold text-green-700 mb-3 sm:mb-4" data-id="element-83">
            Form Submitted Successfully!
          </h2>
          <p className="text-base sm:text-lg mb-3" data-id="element-84">
            Your consultation details have been sent to WhatsApp.
          </p>
          <p className="mb-4" data-id="element-85">
            Please remember to send your tongue picture without brushing.
          </p>
          <button onClick={() => {
        setFormSubmitted(false);
        window.scrollTo(0, 0);
      }} className="px-4 sm:px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-86">
            Submit Another Form
          </button>
        </div> : <form onSubmit={handleSubmit} className="form-group" id="whatsappForm" data-id="element-87">
          {/* Form fields */}
          <div className="space-y-4" data-id="element-88">
            {/* Basic Information */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-89">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-90">
                Basic Information
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-91">
                <div data-id="element-92">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-93">
                    Are You (क्या आप )
                  </span>
                  <select id="wru" className="w-full px-3 py-2 text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.wru} onChange={handleChange} data-id="element-94">
                    <option value="" data-id="element-95">Select Option</option>
                    <option value="Acupuncturist" data-id="element-96">Acupuncturist</option>
                    <option value="Acupressure" data-id="element-97">Acupressure</option>
                    <option value="Sujok" data-id="element-98">Sujok</option>
                    <option value="No Knowledge" data-id="element-99">No Knowledge</option>
                  </select>
                </div>
                <div data-id="element-100">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-101">
                    Reference (संदर्भ)
                  </span>
                  <input type="text" id="reference" placeholder="Reference" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.reference} onChange={handleChange} data-id="element-102" />
                </div>
              </div>
            </div>
            {/* Personal Information */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-103">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-104">
                Personal Information
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-105">
                <div data-id="element-106">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-107">
                    Patient's Full Name (पूरा नाम)
                  </span>
                  <input type="text" id="name" placeholder="Enter Patient's Full Name" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.name} onChange={handleChange} data-id="element-108" />
                </div>
                <div data-id="element-109">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-110">
                    Father / Guardian Name (पिता/अभिभावक का नाम)
                  </span>
                  <input type="text" id="fgname" placeholder="Father / Guardian Name" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.fgname} onChange={handleChange} data-id="element-111" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-112">
                  <div data-id="element-113">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-114">
                      Age (आयु)
                    </span>
                    <input type="text" id="age" placeholder="Age" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.age} onChange={handleChange} data-id="element-115" />
                  </div>
                  <div data-id="element-116">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-117">
                      Gender (लिंग)
                    </span>
                    <select id="gender" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.gender} onChange={handleChange} data-id="element-118">
                      <option value="" data-id="element-119">Select Gender</option>
                      <option value="Male" data-id="element-120">Male</option>
                      <option value="Female" data-id="element-121">Female</option>
                      <option value="Other" data-id="element-122">Other</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-123">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-124">
                    Email (ईमेल)
                  </span>
                  <input type="email" id="email" placeholder="Email" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.email} onChange={handleChange} data-id="element-125" />
                </div>
                <div data-id="element-126">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-127">
                    Address (पता)
                  </span>
                  <input type="text" id="address" placeholder="Address" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.address} onChange={handleChange} data-id="element-128" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-129">
                  <div data-id="element-130">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-131">
                      City (शहर)
                    </span>
                    <input type="text" id="city" placeholder="City" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.city} onChange={handleChange} data-id="element-132" />
                  </div>
                  <div data-id="element-133">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-134">
                      Pin Code (पिन कोड)
                    </span>
                    <input type="text" id="pin" placeholder="Pin Code" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pin} onChange={handleChange} data-id="element-135" />
                  </div>
                </div>
                <div data-id="element-136">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-137">
                    WhatsApp Number (व्हाट्सएप नंबर)
                  </span>
                  <input type="text" id="whatsapp" placeholder="WhatsApp Number" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.whatsapp} onChange={handleChange} data-id="element-138" />
                </div>
              </div>
            </div>
            {/* Health & Lifestyle */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-139">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-140">
                Health & Lifestyle
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-141">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-142">
                  <div data-id="element-143">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-144">
                      Thirst (प्यास)
                    </span>
                    <select id="thirst" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.thirst} onChange={handleChange} data-id="element-145">
                      <option value="" data-id="element-146">Select Water Intake</option>
                      <option value="1-2 Glass" data-id="element-147">1-2 Glass</option>
                      <option value="3-4 Glass" data-id="element-148">3-4 Glass</option>
                      <option value="4-5 Glass" data-id="element-149">4-5 Glass</option>
                      <option value="6-7 Glass" data-id="element-150">6-7 Glass</option>
                      <option value="7-8 Glass" data-id="element-151">7-8 Glass</option>
                      <option value="8-10 Glass" data-id="element-152">8-10 Glass</option>
                      <option value="10+ Glass" data-id="element-153">10+ Glass</option>
                    </select>
                  </div>
                  <div data-id="element-154">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-155">
                      Appetite (भूख)
                    </span>
                    <select id="appetite" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.appetite} onChange={handleChange} data-id="element-156">
                      <option value="" data-id="element-157">Select Appetite</option>
                      <option value="Normal Appetite" data-id="element-158">Normal Appetite</option>
                      <option value="Poor Appetite and Loss of Appetite" data-id="element-159">
                        Poor Appetite and Loss of Appetite
                      </option>
                      <option value="Excess Appetite" data-id="element-160">Excess Appetite</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-161">
                  <div data-id="element-162">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-163">
                      Sleep (नींद)
                    </span>
                    <select id="sleep" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.sleep} onChange={handleChange} data-id="element-164">
                      <option value="" data-id="element-165">Select Sleep Pattern</option>
                      <option value="Normal Sleep" data-id="element-166">Normal Sleep</option>
                      <option value="Difficulty Falling Asleep" data-id="element-167">
                        Difficulty Falling Asleep
                      </option>
                      <option value="Frequent Waking" data-id="element-168">Frequent Waking</option>
                      <option value="Light or Unrestful Sleep" data-id="element-169">
                        Light or Unrestful Sleep
                      </option>
                      <option value="Dreams Disturbed (सपनों से परेशान)" data-id="element-170">
                        Dreams Disturbed (सपनों से परेशान)
                      </option>
                    </select>
                  </div>
                  <div data-id="element-171">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-172">
                      Dreams (सपने)
                    </span>
                    <select id="dreams" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.dreams} onChange={handleChange} data-id="element-173">
                      <option value="" data-id="element-174">Select Dream Pattern</option>
                      <option value="No Dreams" data-id="element-175">No Dreams</option>
                      <option value="Vivid or Disturbed Dreams" data-id="element-176">
                        Vivid or Disturbed Dreams
                      </option>
                      <option value="Nightmares" data-id="element-177">Nightmares</option>
                      <option value="Dream Categories (fearful, surprise, etc)" data-id="element-178">
                        Dream Categories (fearful, surprise, etc)
                      </option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-179">
                  <div data-id="element-180">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-181">
                      Personal Hygiene (व्यक्तिगत स्वच्छता)
                    </span>
                    <input type="text" id="hygiene" placeholder="Personal Hygiene" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.hygiene} onChange={handleChange} data-id="element-182" />
                  </div>
                  <div data-id="element-183">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-184">
                      Addiction if Any (लत यदि कोई हो)
                    </span>
                    <input type="text" id="addiction" placeholder="Addiction if Any" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.addiction} onChange={handleChange} data-id="element-185" />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-186">
                  <div data-id="element-187">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-188">
                      Food Habits and Nutrition (भोजन की आदतें और पोषण)
                    </span>
                    <div className="grid grid-cols-1 gap-2" data-id="element-189">
                      <label className="flex items-center space-x-2" data-id="element-190">
                        <input type="checkbox" name="fruits" checked={formData.foodHabits.fruits} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-191" />
                        <span className="text-sm" data-id="element-192">
                          Take Fruits and Dry fruits & Nuts (soaked over night)
                          (फल और सूखे मेवे और नट्स (रात भर भिगोए हुए))
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-193">
                        <input type="checkbox" name="healthyFood" checked={formData.foodHabits.healthyFood} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-194" />
                        <span className="text-sm" data-id="element-195">
                          Take 3 Times Healthy Food (3 बार स्वस्थ भोजन लें)
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-196">
                        <input type="checkbox" name="noWaterBeforeAfter" checked={formData.foodHabits.noWaterBeforeAfter} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-197" />
                        <span className="text-sm" data-id="element-198">
                          Don't take water before any meal before and after 45
                          min (किसी भी भोजन से पहले और बाद में 45 मिनट तक पानी न
                          पिएं)
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-199">
                        <input type="checkbox" name="waterBeforeAfter" checked={formData.foodHabits.waterBeforeAfter} onChange={handleFoodHabitsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-200" />
                        <span className="text-sm" data-id="element-201">
                          Take water before any meal before and after 45 min
                          (किसी भी भोजन से पहले और बाद में 45 मिनट पानी पिएं)
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Medical History Section */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-202">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-203">
                Medical History
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-204">
                <div data-id="element-205">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-206">
                    Are you Suffering or Suffered in Past with any of the
                    disease(s)
                  </span>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-207">
                    <label className="flex items-center space-x-2" data-id="element-208">
                      <input type="checkbox" name="none" checked={!Object.values(formData.medicalHistory).some(value => value === true)} onChange={e => {
                    if (e.target.checked) {
                      // If None is checked, uncheck all other options
                      const resetMedicalHistory = {};
                      Object.keys(formData.medicalHistory).forEach(key => {
                        resetMedicalHistory[key] = false;
                      });
                      setFormData(prev => ({
                        ...prev,
                        medicalHistory: resetMedicalHistory
                      }));
                    }
                  }} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-209" />
                      <span className="text-sm font-medium" data-id="element-210">None</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-211">
                      <input type="checkbox" name="diabetic" checked={formData.medicalHistory.diabetic} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-212" />
                      <span className="text-sm" data-id="element-213">Diabetic</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-214">
                      <input type="checkbox" name="preDiabetic" checked={formData.medicalHistory.preDiabetic} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-215" />
                      <span className="text-sm" data-id="element-216">Pre-Diabetic</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-217">
                      <input type="checkbox" name="heartProblem" checked={formData.medicalHistory.heartProblem} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-218" />
                      <span className="text-sm" data-id="element-219">Heart Related Problem</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-220">
                      <input type="checkbox" name="kidneyProblem" checked={formData.medicalHistory.kidneyProblem} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-221" />
                      <span className="text-sm" data-id="element-222">Kidney Related Problem</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-223">
                      <input type="checkbox" name="highBloodPressure" checked={formData.medicalHistory.highBloodPressure} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-224" />
                      <span className="text-sm" data-id="element-225">High Blood Pressure</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-226">
                      <input type="checkbox" name="arthritis" checked={formData.medicalHistory.arthritis} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-227" />
                      <span className="text-sm" data-id="element-228">Arthritis</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-229">
                      <input type="checkbox" name="cancer" checked={formData.medicalHistory.cancer} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-230" />
                      <span className="text-sm" data-id="element-231">Cancer</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-232">
                      <input type="checkbox" name="hivAids" checked={formData.medicalHistory.hivAids} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-233" />
                      <span className="text-sm" data-id="element-234">HIV/AIDS</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-235">
                      <input type="checkbox" name="hepatitis" checked={formData.medicalHistory.hepatitis} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-236" />
                      <span className="text-sm" data-id="element-237">Hepatitis</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-238">
                      <input type="checkbox" name="stroke" checked={formData.medicalHistory.stroke} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-239" />
                      <span className="text-sm" data-id="element-240">Stroke</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-241">
                      <input type="checkbox" name="paralysis" checked={formData.medicalHistory.paralysis} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-242" />
                      <span className="text-sm" data-id="element-243">Paralysis</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-244">
                      <input type="checkbox" name="alzheimers" checked={formData.medicalHistory.alzheimers} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-245" />
                      <span className="text-sm" data-id="element-246">Alzheimer's Disease</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-247">
                      <input type="checkbox" name="asthma" checked={formData.medicalHistory.asthma} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-248" />
                      <span className="text-sm" data-id="element-249">Asthma</span>
                    </label>
                    <label className="flex items-center space-x-2" data-id="element-250">
                      <input type="checkbox" name="organTransplant" checked={formData.medicalHistory.organTransplant} onChange={handleMedicalHistoryChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-251" />
                      <span className="text-sm" data-id="element-252">Any Organ Transplant</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* Physical Attributes */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-253">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-254">
                Physical Attributes
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-255">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-256">
                  <div data-id="element-257">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-258">
                      Body Type (शरीर के प्रकार)
                    </span>
                    <select id="body" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.body} onChange={handleChange} data-id="element-259">
                      <option value="" data-id="element-260">Select Body Type</option>
                      <option value="Underweight (कम वजन)" data-id="element-261">
                        Underweight (कम वजन)
                      </option>
                      <option value="Normal weight (सामान्य वजन)" data-id="element-262">
                        Normal weight (सामान्य वजन)
                      </option>
                      <option value="Overweight (अधिक वजन)" data-id="element-263">
                        Overweight (अधिक वजन)
                      </option>
                      <option value="Obese (मोटापा)" data-id="element-264">Obese (मोटापा)</option>
                    </select>
                  </div>
                  <div data-id="element-265">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-266">
                      Temperature (तापमान)
                    </span>
                    <select id="temperature" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.temperature} onChange={handleChange} data-id="element-267">
                      <option value="" data-id="element-268">Select Temperature</option>
                      <option value="Normal" data-id="element-269">Normal</option>
                      <option value="Low" data-id="element-270">Low</option>
                      <option value="High" data-id="element-271">High</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-272">
                  <div data-id="element-273">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-274">
                      Mental Condition (मानसिक हालत)
                    </span>
                    <input type="text" id="mentalcondition" placeholder="Mental Condition" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.mentalcondition} onChange={handleChange} data-id="element-275" />
                  </div>
                  <div data-id="element-276">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-277">
                      Blood Pressure (रक्तचाप)
                    </span>
                    <select id="bp" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bp} onChange={handleChange} data-id="element-278">
                      <option value="" data-id="element-279">Select Blood Pressure</option>
                      <option value="Normal" data-id="element-280">Normal</option>
                      <option value="Low" data-id="element-281">Low</option>
                      <option value="High" data-id="element-282">High</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-283">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-284">
                    Pulse (नाड़ी)
                  </span>
                  <input type="text" id="pulse" placeholder="Pulse" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pulse} onChange={handleChange} data-id="element-285" />
                </div>
              </div>
            </div>
            {/* Bodily Functions */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-286">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-287">
                Bodily Functions
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-288">
                <div data-id="element-289">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-290">
                    Bowel Movement (मल त्याग)
                  </span>
                  <select id="bowel" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bowel} onChange={handleChange} data-id="element-291">
                    <option value="" data-id="element-292">Select Option</option>
                    <option value="1 time in a day (morning)" data-id="element-293">
                      1 time in a day (morning) (दिन में 1 बार (सुबह))
                    </option>
                    <option value="1 Time in a day(Any time)" data-id="element-294">
                      1 Time in a day(Any time) (दिन में 1 बार (किसी भी समय))
                    </option>
                    <option value="2 Times in a day (Morning / Evening)" data-id="element-295">
                      2 Times in a day (Morning / Evening) (दिन में 2 बार (सुबह
                      / शाम))
                    </option>
                    <option value="After meal" data-id="element-296">After meal (भोजन के बाद)</option>
                    <option value="Before meal" data-id="element-297">
                      Before meal (भोजन से पहले)
                    </option>
                    <option value="Other" data-id="element-298">Other (अन्य)</option>
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-299">
                  <div data-id="element-300">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-301">
                      Urine Frequency (In Day) (दिन में पेशाब की आवृत्ति)
                    </span>
                    <select id="urineFrequencyDay" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineFrequencyDay} onChange={handleChange} data-id="element-302">
                      <option value="" data-id="element-303">Select Option</option>
                      <option value="No" data-id="element-304">No (नहीं)</option>
                      <option value="Normal" data-id="element-305">Normal (सामान्य)</option>
                      <option value="Excess" data-id="element-306">Excess (अधिक)</option>
                      <option value="Less" data-id="element-307">Less (कम)</option>
                    </select>
                  </div>
                  <div data-id="element-308">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-309">
                      Urine Frequency (In Night) (रात में पेशाब की आवृत्ति)
                    </span>
                    <select id="urineFrequencyNight" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineFrequencyNight} onChange={handleChange} data-id="element-310">
                      <option value="" data-id="element-311">Select Option</option>
                      <option value="No" data-id="element-312">No (नहीं)</option>
                      <option value="Normal" data-id="element-313">Normal (सामान्य)</option>
                      <option value="Excess" data-id="element-314">Excess (अधिक)</option>
                      <option value="Less" data-id="element-315">Less (कम)</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-316">
                  <div data-id="element-317">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-318">
                      Urine Color (मूत्र का रंग)
                    </span>
                    <select id="urineColor" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineColor} onChange={handleChange} data-id="element-319">
                      <option value="" data-id="element-320">Select Color</option>
                      <option value="हल्का पीला (Pale Yellow)" data-id="element-321">
                        हल्का पीला (Pale Yellow)
                      </option>
                      <option value="गहरा पीला (Dark Yellow)" data-id="element-322">
                        गहरा पीला (Dark Yellow)
                      </option>
                      <option value="नारंगी (Orange)" data-id="element-323">नारंगी (Orange)</option>
                      <option value="गुलाबी या लाल (Pink or Red)" data-id="element-324">
                        गुलाबी या लाल (Pink or Red)
                      </option>
                      <option value="हरा या नीला (Green or Blue)" data-id="element-325">
                        हरा या नीला (Green or Blue)
                      </option>
                      <option value="भूरा (Brown)" data-id="element-326">भूरा (Brown)</option>
                      <option value="सफेद (White)" data-id="element-327">सफेद (White)</option>
                    </select>
                  </div>
                  <div data-id="element-328">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-329">
                      Urine Smell (मूत्र की गंध)
                    </span>
                    <select id="urineSmell" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.urineSmell} onChange={handleChange} data-id="element-330">
                      <option value="" data-id="element-331">Select Smell</option>
                      <option value="Normal Smell (सामान्य गंध)" data-id="element-332">
                        Normal Smell (सामान्य गंध)
                      </option>
                      <option value="तीव्र गंध (Strong Smell)" data-id="element-333">
                        तीव्र गंध (Strong Smell)
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* Physical Appearance */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-334">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-335">
                Physical Appearance
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-336">
                <div data-id="element-337">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-338">
                    Skin (त्वचा)
                  </span>
                  <select id="skin" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.skin} onChange={handleChange} data-id="element-339">
                    <option value="" data-id="element-340">Select Skin Type</option>
                    <option value="सामान्य त्वचा (Normal Skin)" data-id="element-341">
                      सामान्य त्वचा (Normal Skin)
                    </option>
                    <option value="तैलीय त्वचा (Oily Skin)" data-id="element-342">
                      तैलीय त्वचा (Oily Skin)
                    </option>
                    <option value="शुष्क त्वचा (Dry Skin)" data-id="element-343">
                      शुष्क त्वचा (Dry Skin)
                    </option>
                    <option value="मिश्रित त्वचा (Combination Skin)" data-id="element-344">
                      मिश्रित त्वचा (Combination Skin)
                    </option>
                    <option value="संवेदनशील त्वचा (Sensitive Skin)" data-id="element-345">
                      संवेदनशील त्वचा (Sensitive Skin)
                    </option>
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-346">
                  <div data-id="element-347">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-348">
                      Scalp(Hair) (खोपड़ी(बाल))
                    </span>
                    <select id="shair" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.shair} onChange={handleChange} data-id="element-349">
                      <option value="" data-id="element-350">Select Scalp Type</option>
                      <option value="Normal/Balanced Scalp (सामान्य/संतुलित खोपड़ी)" data-id="element-351">
                        Normal/Balanced Scalp (सामान्य/संतुलित खोपड़ी)
                      </option>
                      <option value="Oily Scalp (तैलीय खोपड़ी)" data-id="element-352">
                        Oily Scalp (तैलीय खोपड़ी)
                      </option>
                      <option value="Dry Scalp (रूखी खोपड़ी)" data-id="element-353">
                        Dry Scalp (रूखी खोपड़ी)
                      </option>
                      <option value="Sensitive Scalp (संवेदनशील खोपड़ी)" data-id="element-354">
                        Sensitive Scalp (संवेदनशील खोपड़ी)
                      </option>
                      <option value="Combination Scalp (मिश्रित खोपड़ी)" data-id="element-355">
                        Combination Scalp (मिश्रित खोपड़ी)
                      </option>
                      <option value="Early Baldness (प्रारंभिक गंजापन)" data-id="element-356">
                        Early Baldness (प्रारंभिक गंजापन)
                      </option>
                      <option value="Hair Fall (बाल झड़ना)" data-id="element-357">
                        Hair Fall (बाल झड़ना)
                      </option>
                      <option value="Early Grey Hair (जल्दी सफेद बाल)" data-id="element-358">
                        Early Grey Hair (जल्दी सफेद बाल)
                      </option>
                      <option value="Dandruff (रूसी)" data-id="element-359">Dandruff (रूसी)</option>
                    </select>
                  </div>
                  <div data-id="element-360">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-361">
                      Body(Hair) (शरीर पर बाल)
                    </span>
                    <select id="bhair" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bhair} onChange={handleChange} data-id="element-362">
                      <option value="" data-id="element-363">Select Type</option>
                      <option value="No Hair (कोई बाल नहीं)" data-id="element-364">
                        No Hair (कोई बाल नहीं)
                      </option>
                      <option value="Less Hair (कम बाल)" data-id="element-365">
                        Less Hair (कम बाल)
                      </option>
                      <option value="Normal Hair (सामान्य बाल)" data-id="element-366">
                        Normal Hair (सामान्य बाल)
                      </option>
                      <option value="Excess Hair (अधिक बाल)" data-id="element-367">
                        Excess Hair (अधिक बाल)
                      </option>
                    </select>
                  </div>
                </div>
                <div data-id="element-368">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-369">
                    Nails (नाखून)
                  </span>
                  <select id="nails" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.nails} onChange={handleChange} data-id="element-370">
                    <option value="" data-id="element-371">Select Nail Condition</option>
                    <option value="Normal (सामान्य)" data-id="element-372">Normal (सामान्य)</option>
                    <option value="Dry and brittle (सूखे और भंगुर)" data-id="element-373">
                      Dry and brittle (सूखे और भंगुर)
                    </option>
                    <option value="Soft and brittle (नरम और भंगुर)" data-id="element-374">
                      Soft and brittle (नरम और भंगुर)
                    </option>
                    <option value="Vertical Lines (ऊर्ध्वाधर रेखाएँ)" data-id="element-375">
                      Vertical Lines (ऊर्ध्वाधर रेखाएँ)
                    </option>
                    <option value="Horizontal lines (क्षैतिज रेखाएँ)" data-id="element-376">
                      Horizontal lines (क्षैतिज रेखाएँ)
                    </option>
                    <option value="Discolored (विवर्ण)" data-id="element-377">
                      Discolored (विवर्ण)
                    </option>
                    <option value="Thick (मोटे)" data-id="element-378">Thick (मोटे)</option>
                    <option value="Thin (पतले)" data-id="element-379">Thin (पतले)</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Body & Mouth Odor */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-380">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-381">
                Body & Mouth Odor
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-382">
                <div data-id="element-383">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-384">
                    Body Odor (शरीर की गंध)
                  </span>
                  <select id="bodyOdor" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.bodyOdor} onChange={handleChange} data-id="element-385">
                    <option value="" data-id="element-386">Select Body Odor</option>
                    <option value="Normal / No Odor (सामान्य / कोई गंध नहीं)" data-id="element-387">
                      Normal / No Odor (सामान्य / कोई गंध नहीं)
                    </option>
                    <option value="Fragrant (सुगंधित)" data-id="element-388">
                      Fragrant (सुगंधित)
                    </option>
                    <option value="Woody/Resinous (वुडी/रेजिनस)" data-id="element-389">
                      Woody/Resinous (वुडी/रेजिनस)
                    </option>
                    <option value="Minty (पुदीना)" data-id="element-390">Minty (पुदीना)</option>
                    <option value="Sweet (मीठा)" data-id="element-391">Sweet (मीठा)</option>
                    <option value="Chemical (रासायनिक)" data-id="element-392">
                      Chemical (रासायनिक)
                    </option>
                    <option value="Popcorn (पॉपकॉर्न)" data-id="element-393">
                      Popcorn (पॉपकॉर्न)
                    </option>
                    <option value="Citrus (नींबू)" data-id="element-394">Citrus (नींबू)</option>
                    <option value="Fruity (non-citrus) (फल (गैर-साइट्रस))" data-id="element-395">
                      Fruity (non-citrus) (फल (गैर-साइट्रस))
                    </option>
                    <option value="Pungent (तीखा)" data-id="element-396">Pungent (तीखा)</option>
                    <option value="Putrid (सड़ा हुआ)" data-id="element-397">Putrid (सड़ा हुआ)</option>
                  </select>
                </div>
                <div data-id="element-398">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-399">
                    Mouth Odor (मुंह की गंध)
                  </span>
                  <select id="mouthOdor" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.mouthOdor} onChange={handleChange} data-id="element-400">
                    <option value="" data-id="element-401">Select Mouth Odor</option>
                    <option value="Normal / No Odor (सामान्य / कोई गंध नहीं)" data-id="element-402">
                      Normal / No Odor (सामान्य / कोई गंध नहीं)
                    </option>
                    <option value="Fragrant (सुगंधित)" data-id="element-403">
                      Fragrant (सुगंधित)
                    </option>
                    <option value="Woody/Resinous (वुडी/रेजिनस)" data-id="element-404">
                      Woody/Resinous (वुडी/रेजिनस)
                    </option>
                    <option value="Minty (पुदीना)" data-id="element-405">Minty (पुदीना)</option>
                    <option value="Sweet (मीठा)" data-id="element-406">Sweet (मीठा)</option>
                    <option value="Chemical (रासायनिक)" data-id="element-407">
                      Chemical (रासायनिक)
                    </option>
                    <option value="Popcorn (पॉपकॉर्न)" data-id="element-408">
                      Popcorn (पॉपकॉर्न)
                    </option>
                    <option value="Citrus (नींबू)" data-id="element-409">Citrus (नींबू)</option>
                    <option value="Fruity (non-citrus) (फल (गैर-साइट्रस))" data-id="element-410">
                      Fruity (non-citrus) (फल (गैर-साइट्रस))
                    </option>
                    <option value="Pungent (तीखा)" data-id="element-411">Pungent (तीखा)</option>
                    <option value="Putrid (सड़ा हुआ)" data-id="element-412">Putrid (सड़ा हुआ)</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Body Parts */}
            <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-413">
              <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-414">
                Body Parts
              </h3>
              <div className="grid grid-cols-1 gap-4" data-id="element-415">
                <div data-id="element-416">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-417">
                    Throat (गला)
                  </span>
                  <select id="throat" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.throat} onChange={handleChange} data-id="element-418">
                    <option value="" data-id="element-419">Select Throat Condition</option>
                    <option value="Normal / No Problem (सामान्य / कोई समस्या नहीं)" data-id="element-420">
                      Normal / No Problem (सामान्य / कोई समस्या नहीं)
                    </option>
                    <option value="Tonsillitis (टॉन्सिलाइटिस)" data-id="element-421">
                      Tonsillitis (टॉन्सिलाइटिस)
                    </option>
                    <option value="Strep throat (स्ट्रेप थ्रोट)" data-id="element-422">
                      Strep throat (स्ट्रेप थ्रोट)
                    </option>
                    <option value="Laryngitis (लैरिंजाइटिस)" data-id="element-423">
                      Laryngitis (लैरिंजाइटिस)
                    </option>
                    <option value="Pharyngitis (फेरिंजाइटिस)" data-id="element-424">
                      Pharyngitis (फेरिंजाइटिस)
                    </option>
                  </select>
                </div>
                <div data-id="element-425">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-426">
                    Edema (सूजन)
                  </span>
                  <select id="oedma" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.oedma} onChange={handleChange} data-id="element-427">
                    <option value="" data-id="element-428">Select Edema Type</option>
                    <option value="Normal / No Problem (सामान्य / कोई समस्या नहीं)" data-id="element-429">
                      Normal / No Problem (सामान्य / कोई समस्या नहीं)
                    </option>
                    <option value="Pitting edema (गड्ढादार)" data-id="element-430">
                      Pitting edema (गड्ढादार)
                    </option>
                    <option value="Non pitted type (गैर-गड्ढेदार)" data-id="element-431">
                      Non pitted type (गैर-गड्ढेदार)
                    </option>
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-432">
                  <div data-id="element-433">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-434">
                      Eyes (आँखें)
                    </span>
                    <input type="text" id="eyes" placeholder="Eyes" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.eyes} onChange={handleChange} data-id="element-435" />
                  </div>
                  <div data-id="element-436">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-437">
                      Ears (कान)
                    </span>
                    <input type="text" id="ears" placeholder="Ears" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.ears} onChange={handleChange} data-id="element-438" />
                  </div>
                </div>
                <div data-id="element-439">
                  <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-440">
                    Lips (होंठ)
                  </span>
                  <select id="lips" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.lips} onChange={handleChange} data-id="element-441">
                    <option value="" data-id="element-442">Select Lips Condition</option>
                    <option value="Normal / No Problem (सामान्य / कोई समस्या नहीं)" data-id="element-443">
                      Normal / No Problem (सामान्य / कोई समस्या नहीं)
                    </option>
                    <option value="Chapped lips (फटे होंठ)" data-id="element-444">
                      Chapped lips (फटे होंठ)
                    </option>
                    <option value="Cold sores (herpes simplex) (ठंडे घाव (हरपीज सिम्प्लेक्स))" data-id="element-445">
                      Cold sores (herpes simplex) (ठंडे घाव (हरपीज सिम्प्लेक्स))
                    </option>
                    <option value="Angular cheilitis (कोणीय चेइलिटिस)" data-id="element-446">
                      Angular cheilitis (कोणीय चेइलिटिस)
                    </option>
                    <option value="Eczematous cheilitis (एक्जिमेटस चेइलिटिस)" data-id="element-447">
                      Eczematous cheilitis (एक्जिमेटस चेइलिटिस)
                    </option>
                    <option value="Infective cheilitis (संक्रामक चेइलिटिस)" data-id="element-448">
                      Infective cheilitis (संक्रामक चेइलिटिस)
                    </option>
                    <option value="Actinic cheilitis (एक्टिनिक चेइलिटिस)" data-id="element-449">
                      Actinic cheilitis (एक्टिनिक चेइलिटिस)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            {/* Female-specific section */}
            {isFemale && <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-450">
                <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-451">
                  Female-specific Information
                </h3>
                <div className="grid grid-cols-1 gap-4" data-id="element-452">
                  <div data-id="element-453">
                    <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-454">
                      Are you Pregnant? (क्या आप गर्भवती हैं?)
                    </span>
                    <select id="isPregnant" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.isPregnant} onChange={handleChange} data-id="element-455">
                      <option value="" data-id="element-456">Select Option</option>
                      <option value="Yes" data-id="element-457">Yes (हां)</option>
                      <option value="No" data-id="element-458">No (नहीं)</option>
                    </select>
                  </div>
                  {formData.isPregnant === 'Yes' && <div data-id="element-459">
                      <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-460">
                        Pregnancy Month (गर्भावस्था का महीना)
                      </span>
                      <select id="pregnancyMonth" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pregnancyMonth} onChange={handleChange} data-id="element-461">
                        <option value="" data-id="element-462">Select Month</option>
                        <option value="1" data-id="element-463">1</option>
                        <option value="2" data-id="element-464">2</option>
                        <option value="3" data-id="element-465">3</option>
                        <option value="4" data-id="element-466">4</option>
                        <option value="5" data-id="element-467">5</option>
                        <option value="6" data-id="element-468">6</option>
                        <option value="7" data-id="element-469">7</option>
                        <option value="8" data-id="element-470">8</option>
                        <option value="9" data-id="element-471">9</option>
                        <option value="10" data-id="element-472">10</option>
                      </select>
                    </div>}
                  {formData.isPregnant !== 'Yes' && <>
                      <div data-id="element-473">
                        <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-474">
                          Menopause? (रजोनिवृत्ति?)
                        </span>
                        <select id="isMenopause" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.isMenopause} onChange={handleChange} data-id="element-475">
                          <option value="" data-id="element-476">Select Option</option>
                          <option value="Yes" data-id="element-477">Yes (हां)</option>
                          <option value="No" data-id="element-478">No (नहीं)</option>
                        </select>
                      </div>
                      {formData.isMenopause !== 'Yes' && <>
                          <div data-id="element-479">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-480">
                              Mensturation Duration in Days (मासिक धर्म की अवधि
                              दिनों में)
                            </span>
                            <select id="mensturation" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.mensturation} onChange={handleChange} data-id="element-481">
                              <option value="" data-id="element-482">Select Option</option>
                              <option value="Comes before 16 days (16 दिनों से पहले आता है)" data-id="element-483">
                                Comes before 16 days (16 दिनों से पहले आता है)
                              </option>
                              <option value="Comes 16 days (16 दिनों में आता है)" data-id="element-484">
                                Comes 16 days (16 दिनों में आता है)
                              </option>
                              <option value="Comes 17 days (17 दिनों में आता है)" data-id="element-485">
                                Comes 17 days (17 दिनों में आता है)
                              </option>
                              <option value="Comes 18 days (18 दिनों में आता है)" data-id="element-486">
                                Comes 18 days (18 दिनों में आता है)
                              </option>
                              <option value="Comes 19 days (19 दिनों में आता है)" data-id="element-487">
                                Comes 19 days (19 दिनों में आता है)
                              </option>
                              <option value="Comes 20 days (20 दिनों में आता है)" data-id="element-488">
                                Comes 20 days (20 दिनों में आता है)
                              </option>
                              <option value="Comes 21 days (21 दिनों में आता है)" data-id="element-489">
                                Comes 21 days (21 दिनों में आता है)
                              </option>
                              <option value="Comes 22 days (22 दिनों में आता है)" data-id="element-490">
                                Comes 22 days (22 दिनों में आता है)
                              </option>
                              <option value="Comes 23 days (23 दिनों में आता है)" data-id="element-491">
                                Comes 23 days (23 दिनों में आता है)
                              </option>
                              <option value="Comes 24 days (24 दिनों में आता है)" data-id="element-492">
                                Comes 24 days (24 दिनों में आता है)
                              </option>
                              <option value="Comes 25 days (25 दिनों में आता है)" data-id="element-493">
                                Comes 25 days (25 दिनों में आता है)
                              </option>
                              <option value="Comes 26 days (26 दिनों में आता है)" data-id="element-494">
                                Comes 26 days (26 दिनों में आता है)
                              </option>
                              <option value="Comes 27 days (27 दिनों में आता है)" data-id="element-495">
                                Comes 27 days (27 दिनों में आता है)
                              </option>
                              <option value="Comes 28 days (28 दिनों में आता है)" data-id="element-496">
                                Comes 28 days (28 दिनों में आता है)
                              </option>
                              <option value="Comes 29 days (29 दिनों में आता है)" data-id="element-497">
                                Comes 29 days (29 दिनों में आता है)
                              </option>
                              <option value="Comes 30 days (30 दिनों में आता है)" data-id="element-498">
                                Comes 30 days (30 दिनों में आता है)
                              </option>
                              <option value="Comes 31 days (31 दिनों में आता है)" data-id="element-499">
                                Comes 31 days (31 दिनों में आता है)
                              </option>
                              <option value="More than 36 days (36 दिनों से अधिक)" data-id="element-500">
                                More than 36 days (36 दिनों से अधिक)
                              </option>
                            </select>
                          </div>
                          <div data-id="element-501">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-502">
                              Cycle days (चक्र दिवस)
                            </span>
                            <select id="cdays" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.cdays} onChange={handleChange} data-id="element-503">
                              <option value="" data-id="element-504">Select Option</option>
                              <option value="Does not comes without Medicine (दवा के बिना नहीं आता है)" data-id="element-505">
                                Does not comes without Medicine (दवा के बिना
                                नहीं आता है)
                              </option>
                              <option value="1 Day (1 दिन)" data-id="element-506">
                                1 Day (1 दिन)
                              </option>
                              <option value="2 Days (2 दिन)" data-id="element-507">
                                2 Days (2 दिन)
                              </option>
                              <option value="3 Days (3 दिन)" data-id="element-508">
                                3 Days (3 दिन)
                              </option>
                              <option value="4 Days (4 दिन)" data-id="element-509">
                                4 Days (4 दिन)
                              </option>
                              <option value="5 Days (5 दिन)" data-id="element-510">
                                5 Days (5 दिन)
                              </option>
                              <option value="6 Days (6 दिन)" data-id="element-511">
                                6 Days (6 दिन)
                              </option>
                              <option value="7 Days (7 दिन)" data-id="element-512">
                                7 Days (7 दिन)
                              </option>
                              <option value="More than 7 Days (7 दिनों से अधिक)" data-id="element-513">
                                More than 7 Days (7 दिनों से अधिक)
                              </option>
                              <option value="Does not stops without medicine (दवा के बिना रुकता नहीं है)" data-id="element-514">
                                Does not stops without medicine (दवा के बिना
                                रुकता नहीं है)
                              </option>
                            </select>
                          </div>
                          <div data-id="element-515">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-516">
                              Painful (दर्दनाक)
                            </span>
                            <div className="grid grid-cols-2 gap-2" data-id="element-517">
                              <label className="flex items-center space-x-2" data-id="element-518">
                                <input type="checkbox" name="noPain" checked={formData.painful.noPain} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-519" />
                                <span className="text-sm" data-id="element-520">
                                  No Pain (कोई दर्द नहीं)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-521">
                                <input type="checkbox" name="before" checked={formData.painful.before} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-522" />
                                <span className="text-sm" data-id="element-523">Before (पहले)</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-524">
                                <input type="checkbox" name="during" checked={formData.painful.during} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-525" />
                                <span className="text-sm" data-id="element-526">During (दौरान)</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-527">
                                <input type="checkbox" name="after" checked={formData.painful.after} onChange={handlePainfulChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-528" />
                                <span className="text-sm" data-id="element-529">After (बाद)</span>
                              </label>
                            </div>
                          </div>
                          <div data-id="element-530">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-531">
                              Clots (थक्के)
                            </span>
                            <select id="clots" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.clots} onChange={handleChange} data-id="element-532">
                              <option value="" data-id="element-533">Select Option</option>
                              <option value="Yes (हां)" data-id="element-534">Yes (हां)</option>
                              <option value="No (नहीं)" data-id="element-535">No (नहीं)</option>
                            </select>
                          </div>
                          <div data-id="element-536">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-537">
                              Type of Flow (प्रवाह का प्रकार)
                            </span>
                            <select id="flowType" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.flowType} onChange={handleChange} data-id="element-538">
                              <option value="" data-id="element-539">Select Flow Type</option>
                              <option value="Scanty (अल्प)" data-id="element-540">
                                Scanty (अल्प)
                              </option>
                              <option value="Normal (सामान्य)" data-id="element-541">
                                Normal (सामान्य)
                              </option>
                              <option value="Excess (अधिकता)" data-id="element-542">
                                Excess (अधिकता)
                              </option>
                            </select>
                          </div>
                          {/* Reproductive & Gynecological Conditions */}
                          <div data-id="element-543">
                            <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-544">
                              Reproductive & Gynecological Conditions
                            </span>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-545">
                              <label className="flex items-center space-x-2" data-id="element-546">
                                <input type="checkbox" name="none" checked={!Object.values(formData.gynecologicalConditions).some(value => value === true)} onChange={e => {
                        if (e.target.checked) {
                          // If None is checked, uncheck all other options
                          const resetGynConditions = {};
                          Object.keys(formData.gynecologicalConditions).forEach(key => {
                            resetGynConditions[key] = false;
                          });
                          setFormData(prev => ({
                            ...prev,
                            gynecologicalConditions: resetGynConditions
                          }));
                        }
                      }} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-547" />
                                <span className="text-sm font-medium" data-id="element-548">
                                  None
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-549">
                                <input type="checkbox" name="cancers" checked={formData.gynecologicalConditions.cancers} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-550" />
                                <span className="text-sm" data-id="element-551">
                                  Cancers: Breast cancer, ovarian cancer, and
                                  cervical cancer
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-552">
                                <input type="checkbox" name="endometriosis" checked={formData.gynecologicalConditions.endometriosis} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-553" />
                                <span className="text-sm" data-id="element-554">Endometriosis</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-555">
                                <input type="checkbox" name="pcos" checked={formData.gynecologicalConditions.pcos} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-556" />
                                <span className="text-sm" data-id="element-557">
                                  Polycystic Ovary Syndrome (PCOS)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-558">
                                <input type="checkbox" name="dysmenorrhea" checked={formData.gynecologicalConditions.dysmenorrhea} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-559" />
                                <span className="text-sm" data-id="element-560">
                                  Dysmenorrhea (cramps)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-561">
                                <input type="checkbox" name="amenorrhea" checked={formData.gynecologicalConditions.amenorrhea} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-562" />
                                <span className="text-sm" data-id="element-563">
                                  Amenorrhea (absent periods)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-564">
                                <input type="checkbox" name="menorrhagia" checked={formData.gynecologicalConditions.menorrhagia} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-565" />
                                <span className="text-sm" data-id="element-566">
                                  Menorrhagia (heavy bleeding)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-567">
                                <input type="checkbox" name="pms" checked={formData.gynecologicalConditions.pms} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-568" />
                                <span className="text-sm" data-id="element-569">
                                  Premenstrual Syndrome (PMS)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-570">
                                <input type="checkbox" name="adenomyosis" checked={formData.gynecologicalConditions.adenomyosis} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-571" />
                                <span className="text-sm" data-id="element-572">Adenomyosis</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-573">
                                <input type="checkbox" name="utis" checked={formData.gynecologicalConditions.utis} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-574" />
                                <span className="text-sm" data-id="element-575">
                                  Urinary Tract Infections (UTIs)
                                </span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-576">
                                <input type="checkbox" name="anemia" checked={formData.gynecologicalConditions.anemia} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-577" />
                                <span className="text-sm" data-id="element-578">Anemia</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-579">
                                <input type="checkbox" name="infertility" checked={formData.gynecologicalConditions.infertility} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-580" />
                                <span className="text-sm" data-id="element-581">Infertility</span>
                              </label>
                              <label className="flex items-center space-x-2" data-id="element-582">
                                <input type="checkbox" name="fibroidsCysts" checked={formData.gynecologicalConditions.fibroidsCysts} onChange={handleGynecologicalConditionsChange} className="rounded text-blue-600 focus:ring-blue-500" data-id="element-583" />
                                <span className="text-sm" data-id="element-584">
                                  Fibroids / Cysts
                                </span>
                              </label>
                            </div>
                          </div>
                        </>}
                    </>}
                </div>
              </div>}
          </div>
          {/* Medical History */}
          <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-585">
            <h3 className="text-md font-semibold text-blue-800 mb-2" data-id="element-586">
              Complaint & Illness Information
            </h3>
            <div className="grid grid-cols-1 gap-4" data-id="element-587">
              <div data-id="element-588">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-589">
                  Chief / Main Complaint (मुख्य/मुख्य शिकायत)
                </span>
                <textarea id="ccomplaint" placeholder="Chief / Main Complaint" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.ccomplaint} onChange={handleChange} data-id="element-590"></textarea>
              </div>
              <div data-id="element-591">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-592">
                  Present Illness (वर्तमान बीमारी)
                </span>
                <textarea id="presentill" placeholder="Present Illness" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.presentill} onChange={handleChange} data-id="element-593"></textarea>
              </div>
              <div data-id="element-594">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-595">
                  Past Illness (पिछली बीमारी)
                </span>
                <textarea id="pastill" placeholder="Past Illness" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.pastill} onChange={handleChange} data-id="element-596"></textarea>
              </div>
              <div data-id="element-597">
                <span className="block text-sm font-medium text-gray-700 mb-1" data-id="element-598">
                  Family History (पारिवारिक इतिहास)
                </span>
                <textarea id="fhistory" placeholder="Family History" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" value={formData.fhistory} onChange={handleChange} data-id="element-599"></textarea>
              </div>
            </div>
          </div>
          {/* Consent checkbox */}
          <div className="p-3 bg-blue-50 rounded-md mb-2" data-id="element-600">
            <div className="flex items-start" data-id="element-601">
              <div className="flex items-center h-5" data-id="element-602">
                <input id="terms" type="checkbox" checked={agreedToTerms} onChange={e => setAgreedToTerms(e.target.checked)} className="w-4 h-4 border border-gray-300 rounded text-blue-600 focus:ring-blue-500" required data-id="element-603" />
              </div>
              <div className="ml-3 text-sm" data-id="element-604">
                <label htmlFor="terms" className="font-medium text-gray-700" data-id="element-605">
                  I have read and I agree to the{' '}
                  <button type="button" onClick={() => setShowConsentPopup(true)} className="text-blue-600 hover:text-blue-800 underline focus:outline-none" data-id="element-606">
                    Informed Consent Form
                  </button>
                </label>
              </div>
            </div>
          </div>
          {/* Submit Section */}
          <div className="mt-6 text-center" data-id="element-607">
            <p className="font-bold mb-4 text-sm sm:text-base" data-id="element-608">
              Also Send Tongue Pic Without Brushing in WhatsApp (व्हाट्सएप पर
              बिना ब्रश किए जीभ की तस्वीर भी भेजें)
            </p>
            <button type="submit" disabled={isSubmitting} className="w-full sm:w-auto px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-md transition-colors" data-id="element-609">
              {isSubmitting ? 'Sending...' : 'Send Via WhatsApp to 918303699990'}
            </button>
          </div>
        </form>}
    </div>;
};